/**
 * Cleans up Product Fruits when user logs out.
 * Call this before Auth0 logout to prevent stale Product Fruits state.
 */
export function destroyProductFruits(): void {
  if (typeof window !== 'undefined' && (window as any).productFruits?.services?.destroy) {
    (window as any).productFruits.services.destroy();
  }
}

export type ElvinSection = 'conversation' | 'quick-links' | 'newsfeed' | 'human-handover' | 'feedback';

export type ToggleElvinOptions = {
  state?: boolean;
  section?: ElvinSection;
  focusId?: number | string;
};

/**
 * Opens or toggles the Elvin Copilot widget.
 * @see https://help.productfruits.com/en/article/elvin-custom-trigger-api
 */
export function toggleElvinWidget(options?: ToggleElvinOptions): void {
  if (typeof window !== 'undefined' && (window as any).$productFruits?.push) {
    (window as any).$productFruits.push(['do', 'toggle-elvin-widget', options ?? {}]);
  }
}

export type SendMessageToElvinOptions = {
  message: string;
  sendImmediately?: boolean;
  startNewTopic?: boolean;
};

/**
 * Sends a message to Elvin or pre-fills the input.
 * @see https://help.productfruits.com/en/article/elvin-custom-trigger-api
 */
export function sendMessageToElvin(options: SendMessageToElvinOptions): void {
  if (typeof window !== 'undefined' && (window as any).$productFruits?.push) {
    (window as any).$productFruits.push(['do', 'send-message-to-elvin', options]);
  }
}

/**
 * Notifies Product Fruits that the SPA route changed. Required when disableLocationChangeDetection is used.
 * Call this whenever the URL changes so tours/hints can match correctly.
 * @see https://help.productfruits.com/en/article/developers-installation-to-other-web-environments#single-page-applications
 */
export function notifyProductFruitsPageChanged(): void {
  if (typeof window !== 'undefined' && (window as any).$productFruits?.push) {
    (window as any).$productFruits.push(['pageChanged']);
  }
}
